module.exports = __webpack_public_path__ + "img/generic-no-bg.14f8507f.png";